/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_Faq_A1Inputs */

const en_invite_page_faq_a1 = /** @type {(inputs: Invite_Page_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only focus time from successful plantings after someone enters your invite code counts. Past focus time won’t count.`)
};

const ar_invite_page_faq_a1 = /** @type {(inputs: Invite_Page_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يُحتسب فقط وقت التركيز من الزراعة الناجحة بعد إدخال رمز دعوتك. وقت التركيز السابق لا يُحتسب.`)
};

const de_invite_page_faq_a1 = /** @type {(inputs: Invite_Page_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Fokuszeit erfolgreicher Pflanzungen nach Eingabe deines Einladungscodes zählt. Frühere Fokuszeit zählt nicht.`)
};

const es_invite_page_faq_a1 = /** @type {(inputs: Invite_Page_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo el tiempo de concentración de plantaciones exitosas tras introducir tu código de invitación cuenta. El tiempo anterior no cuenta.`)
};

const fr_invite_page_faq_a1 = /** @type {(inputs: Invite_Page_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seul le temps de concentration des plantations réussies après la saisie de votre code d’invitation compte. Le temps passé ne compte pas.`)
};

const it_invite_page_faq_a1 = /** @type {(inputs: Invite_Page_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta solo il tempo di concentrazione delle piantagioni riuscite dopo l’inserimento del tuo codice invito. Il tempo precedente non conta.`)
};

const ja_invite_page_faq_a1 = /** @type {(inputs: Invite_Page_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相手があなたの招待コードを入力した後、植樹に成功した集中時間だけがカウントされます。過去の集中時間はカウントされません。`)
};

const ko_invite_page_faq_a1 = /** @type {(inputs: Invite_Page_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상대방이 내 초대 코드를 입력한 후 나무 심기에 성공한 집중 시간만 반영돼요. 이전 집중 시간은 반영되지 않아요.`)
};

const pt_br_invite_page_faq_a1 = /** @type {(inputs: Invite_Page_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só o tempo de foco de plantios bem-sucedidos após inserir seu código de convite conta. O tempo anterior não conta.`)
};

const ru_invite_page_faq_a1 = /** @type {(inputs: Invite_Page_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Засчитывается только время фокусировки за успешные посадки после ввода вашего кода приглашения. Прошлое время не учитывается.`)
};

const th_invite_page_faq_a1 = /** @type {(inputs: Invite_Page_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นับเฉพาะเวลาโฟกัสจากการปลูกสำเร็จหลังจากกรอกรหัสเชิญของคุณ เวลาโฟกัสก่อนหน้านั้นไม่นับ`)
};

const tr_invite_page_faq_a1 = /** @type {(inputs: Invite_Page_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet kodun girildikten sonra başarılı dikimlerden gelen odaklanma süresi sayılır. Geçmiş süre sayılmaz.`)
};

const zh_cn_invite_page_faq_a1 = /** @type {(inputs: Invite_Page_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对方输入你的邀请码后，成功种植的专注时间才会计入。过去的专注时间不会计入。`)
};

const zh_tw_invite_page_faq_a1 = /** @type {(inputs: Invite_Page_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`對方輸入你的邀請碼後，成功種植的專注時間才會計入。過去的專注時間不會計入。`)
};

/**
* | output |
* | --- |
* | "Only focus time from successful plantings after someone enters your invite code counts. Past focus time won’t count." |
*
* @param {Invite_Page_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_faq_a1 = /** @type {((inputs?: Invite_Page_Faq_A1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_Faq_A1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_faq_a1(inputs)
	if (locale === "ar") return ar_invite_page_faq_a1(inputs)
	if (locale === "de") return de_invite_page_faq_a1(inputs)
	if (locale === "es") return es_invite_page_faq_a1(inputs)
	if (locale === "fr") return fr_invite_page_faq_a1(inputs)
	if (locale === "it") return it_invite_page_faq_a1(inputs)
	if (locale === "ja") return ja_invite_page_faq_a1(inputs)
	if (locale === "ko") return ko_invite_page_faq_a1(inputs)
	if (locale === "pt_br") return pt_br_invite_page_faq_a1(inputs)
	if (locale === "ru") return ru_invite_page_faq_a1(inputs)
	if (locale === "th") return th_invite_page_faq_a1(inputs)
	if (locale === "tr") return tr_invite_page_faq_a1(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_faq_a1(inputs)
	return zh_tw_invite_page_faq_a1(inputs)
});